import { GetMaterialKeywordsAvailableTokens } from 'store/Project/ProjectStateUtils'
import { ProjectState } from 'store/Project/ProjectTypes'

export const refreshMaterialFilter = (state: ProjectState) => {
  const availableFilters = GetMaterialKeywordsAvailableTokens(state.flatView)

  const newState: ProjectState = {
    ...state,
    filters: {
      ...state.filters,
      byMaterialKeywords: {
        ...state.filters.byMaterialKeywords,
        filter: {
          ...state.filters.byMaterialKeywords.filter,
          availableFilters,
        },
        active:
          state.filters?.byMaterialKeywords?.active &&
          Object.keys(availableFilters || {}).length > 0,
      },
    },
  }

  return newState
}
